const Joi = require('joi')
const { walletAddressField } = require('./fields')

const walletAddressSchema = Joi.object({
    walletAddress: walletAddressField,
});

module.exports = walletAddressSchema;